import React from 'react';
import Table from 'react-bootstrap/Table';
import { FaList, FaCloudDownloadAlt } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import ImportExportAPI from '../../../api/ImportExportAPI';
import DocumentAPI from '../../../api/DocumentAPI';
import Util from '../../../util/Util';
import withRouter from '../../../util/WithRouter';
import Display from '../../../util/Display';
import Const from '../../../util/Constants';
import ApiUiController from '../../../controller/ApiUiController';

class ImportList extends React.Component {

  constructor(props) {
    super(props);
    this.imports = [];
    this.state = { inApiCall: true };
    this.path = this.props.match.path;

    const model = reactLocalStorage.getObject(Const.Model).import;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
    this.Restrict = Util.isAllow(model.permission, Const.PermRestricAcc);
  }

  componentDidMount() {
    if (this.List) {
      const filters = [];
      if (this.Restrict) {
        const user = reactLocalStorage.getObject(Const.LoggedInUser);
        user.child.push(user.user_id);
        filters.push({
          field: 'created_by', type: 'multiselect~user',
          condition: 'in', value: `${Const.Opt}${user.child.join(Const.Opt)}${Const.Opt}`
        });
      }
      ImportExportAPI.importList(filters, this.onReceived, this.onFail);
    }
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = imports => { this.imports = imports.data; this.setState({ inApiCall: false }); };

  confirmDelete = index => {
    Util.confirmAlert('Delete', 'Are you sure you want to delet', 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      ImportExportAPI.importDelete(this.imports[index].id, this.onDelete, this.onFail);
    });
  };
  onDelete = () => {
    Util.showNotification('Successful', 'Imported deleted successfully', 'success');
    ImportExportAPI.importList(this.onReceived, this.onFail);
  };

  downalod = async index => {
    const res = await DocumentAPI.getPublicMediaUrl(this.imports[index].import_file);
    window.open(res.url, '_blank');
  };

  details = index => this.props.navigate(
    `${this.path}/view/${this.imports[index].import_file}/${this.imports[index].result_json}`);

  render() {
    if (!this.List) return null;
    let importUI = this.imports.map((importMod, _i) => (
      <tr key={`import_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{Display.ModulLabelValue(importMod.module)}</td>
        <td>{importMod.file_name}</td>
        <td>
          {
            importMod.import_status === 1 ? 'Not Started' :
              importMod.import_status === 2 ? 'In Progress' :
                'Successfull'
          }
        </td>
        <td>{Display.ModelLabelValue('user', importMod.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(importMod.created_date)}</td>
        <td>
          <span className="buttons quote" onClick={() => this.downalod(_i)}>
            <FaCloudDownloadAlt /> CSV
          </span>
          {importMod.import_status === 3 &&
            <span className="buttons update" onClick={() => this.details(_i)}>
              <FaList /> Details
            </span>
          }
          { /*
          <span onClick={() => this.confirmDelete(_i)} className="buttons delete">
            <FaTrash /> Delete
          </span>
          */
          }
        </td>
      </tr>
    ));

    if (this.imports.length === 0) importUI = <tr><td colSpan="8">No Records Found</td></tr>;

    return (
      <div className="sectionlist pt-3">
        <div className="container-fluid">
          <div className="row">

            <div className="col-md-6 pb-3"> <h3>Imports</h3> </div>

            <div className="col-md-12">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Module</th>
                    <th>File Name</th>
                    <th>Status</th>
                    <th>Created By</th>
                    <th>Created Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <ApiUiController inApiCall={this.props.inApiCall}>
                    {importUI}
                  </ApiUiController>
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(ImportList);
